import { render, staticRenderFns } from "./planBuy.vue?vue&type=template&id=7be6553a"
import script from "./planBuy.vue?vue&type=script&lang=js"
export * from "./planBuy.vue?vue&type=script&lang=js"
import style0 from "./planBuy.vue?vue&type=style&index=0&id=7be6553a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports